<template>
  <div>
    <van-form validate-first @submit="getCoupon" style="margin-top: 50px;padding: 0 12px;">
      <!-- 通过 pattern 进行正则校验 -->
      <LicensePlate style="font-size: 18px" v-model="carNumber" @change="handleChange" />
      <!-- <van-field v-model="carNumber" label="车牌号" name="pattern" placeholder="请输入您的车牌号"
        :rules="[{ pattern, message: '请输入正确车牌号' }]" /> -->

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">领取优惠券</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { couponPublic } from "@/api/receiveCoupon"
import { Toast } from 'vant';
export default {
  props: {

  },
  data() {
    return {
      receiveCouponInfo: {},
      carNumber: '',
      pattern: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z](?:[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]|[A-EF-GHJ-K][A-HJ-NP-Z0-9][0-9]{4}|[0-9]{5}[A-EF-GHJ-K])$/,
      // pattern: /^[\u4e00-\u9fa5][A-Z]{1}[A-Z0-9]{5}$/,
    };
  },
  components: {

  },
  computed: {

  },
  watch: {

  },
  created() {
    console.log(this.$route.query);
    this.receiveCouponInfo = this.$route.query

  },
  mounted() {

  },
  methods: {
    handleChange(val) {
      // val 包含 array, value, pass 等属性
      console.log('车牌变化:', val.value, '是否通过验证:', val.pass)
      this.carNumber = val.value
    },
    async getCoupon() {
      const { data } = await couponPublic({
        parkId: this.receiveCouponInfo.parkId,
        orgCode: this.receiveCouponInfo.orgCode,
        requestTime: this.receiveCouponInfo.requestTime,
        seqNo: this.receiveCouponInfo.seqNo,
        merhantId: this.receiveCouponInfo.merhantId,
        reqSource: 'KUNXIANG',
        carNo: this.carNumber,
      })
      if (data.code == 200) {
        // 领取成功后清空车牌号
        this.carNumber = ''
        Toast(data.msg)
      } else {
        Toast(data.msg)
      }
      console.log(data);
    }
  },
};
</script>

<style scoped lang="less"></style>
